import {ICreditOffer} from "../types/ICreditOffer";

export const getEffectiveInterestRate = (offer: ICreditOffer): number => {
    if (offer.is_fixed_interest_rate) {
        return offer.fixed_interest_rate_percent;
    }
    return offer.vibor_rate > 0 ? offer.vibor_rate + offer.margin : 0;
};
import {ICreditOffer} from "../types/ICreditOffer";

export const getEffectiveInterestRate = (offer: ICreditOffer): number => {
    if (offer.is_fixed_interest_rate) {
        return offer.fixed_interest_rate_percent;
    }
    return offer.vibor_rate > 0 ? offer.vibor_rate + offer.margin : 0;
};
